const RETAILERS_KEYS = {
  RETAILERS: () => ['retailers'],
  RETAILERS_PAGINATED: (params = {}) => [...RETAILERS_KEYS.RETAILERS(), 'paginated', params],
  RETAILERS_INFINITE: (params = {}) => [...RETAILERS_KEYS.RETAILERS(), 'infinite', params],
  RETAILER: (uid) => [...RETAILERS_KEYS.RETAILERS(), uid],
  RETAILERS_LOOKS: () => [...RETAILERS_KEYS.RETAILERS(), 'looks'],
  RETAILER_LOOKS: (uid) => [...RETAILERS_KEYS.RETAILERS_LOOKS(), uid],
  RETAILERS_FAVORITE_PRODUCTS: () => [...RETAILERS_KEYS.RETAILERS(), 'favorite-products'],
  RETAILER_FAVORITE_PRODUCTS: (uid) => [...RETAILERS_KEYS.RETAILERS_FAVORITE_PRODUCTS(), uid],
};

export default RETAILERS_KEYS;
